import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "../cierreRecepcion/cierreRe.css";
import "./cuadreEfectivo.css";
import Alert from "../../modal/alert";
import { fetchSedes } from "../../utils/sedesApi";

class CuadreEfectivo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sede: "",
      sedes: [],
      desde: moment().format("YYYY-MM-DD"),
      hasta: moment().format("YYYY-MM-DD"),
      filas: [],
      consultando: false,
      mensajealerta: false,
      tituloM: "",
      cuerpoM: "",
    };
  }

  componentDidMount() {
    if (this.props.usuario1.nivel !== "1") {
      this.setState({ sede: this.props.usuario1.sede });
    }
    this.cargarSedes();
  }

  cargarSedes = () => {
    fetchSedes().then((sedes) => {
      this.setState({ sedes: Array.isArray(sedes) ? sedes : [] });
    });
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  aviso = (titulo, cuerpo) => {
    this.setState({
      mensajealerta: true,
      tituloM: titulo,
      cuerpoM: cuerpo,
    });
  };

  consultar = () => {
    if (this.state.consultando) {
      return;
    }
    if (!this.state.desde || !this.state.hasta) {
      this.aviso("Cuadre Efectivo.", "Debe indicar desde y hasta.");
      return;
    }
    if (this.props.usuario1.nivel === "1" && String(this.state.sede).length === 0) {
      this.aviso("Cuadre Efectivo.", "Debe seleccionar la sede.");
      return;
    }
    const data = new FormData();
    data.append("boton", "consultar");
    data.append("desde", this.state.desde);
    data.append("hasta", this.state.hasta);
    data.append("sede", this.state.sede);
    this.setState({ consultando: true });
    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/cuadreEfectivo.php",
        data,
        { headers: { "Content-Type": "text/html" } }
      )
      .then((res) => {
        let dataRes = res.data;
        if (typeof dataRes === "string") {
          try {
            dataRes = JSON.parse(dataRes);
          } catch (e) {
            this.cargarSedes();
            this.aviso(
              "Cuadre Efectivo.",
              "El servidor no respondio la consulta. Vuelva a abrir la sede."
            );
            return;
          }
        }
        if (!dataRes || dataRes.variable1 !== true) {
          const msg =
            dataRes && typeof dataRes.variable2 === "string"
              ? dataRes.variable2
              : "No hay efectivo en el rango y la sede seleccionados.";
          this.setState({ filas: [] });
          this.cargarSedes();
          this.aviso("Cuadre Efectivo.", msg);
          return;
        }
        const filas = Array.isArray(dataRes.variable2) ? dataRes.variable2 : [];
        this.setState({ filas });
      })
      .catch(() => {
        this.cargarSedes();
        this.aviso(
          "Cuadre Efectivo.",
          "No se pudo consultar el cuadre. Si las sedes no aparecen, espere un momento y vuelva a entrar."
        );
      })
      .finally(() => {
        this.setState({ consultando: false });
      });
  };

  marcarRevision = (fila, marcado) => {
    const revisado = marcado ? "1" : "0";
    const data = new FormData();
    data.append("boton", "guardarRevision");
    data.append("fecha", fila.variable1);
    data.append("sede", fila.variable2);
    data.append("revisado", revisado);
    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/cuadreEfectivo.php",
        data,
        { headers: { "Content-Type": "text/html" } }
      )
      .then((res) => {
        if (!res.data.variable1) {
          this.aviso("Cuadre Efectivo.", "No se pudo guardar la revision.");
          return;
        }
        const filas = this.state.filas.map((item) => {
          if (item.variable1 === fila.variable1 && item.variable2 === fila.variable2) {
            return { ...item, variable5: revisado };
          }
          return item;
        });
        this.setState({ filas });
      })
      .catch(() => {
        this.aviso("Cuadre Efectivo.", "No se pudo guardar la revision.");
      });
  };

  imprimir = () => {
    if (!this.state.desde || !this.state.hasta) {
      this.aviso("Cuadre Efectivo.", "Debe indicar desde y hasta.");
      return;
    }
    if (this.props.usuario1.nivel === "1" && String(this.state.sede).length === 0) {
      this.aviso("Cuadre Efectivo.", "Debe seleccionar la sede.");
      return;
    }
    const data = new FormData();
    data.append("desde", this.state.desde);
    data.append("hasta", this.state.hasta);
    data.append("sede", this.state.sede);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteCuadreEfectivo.php",
      responseType: "arraybuffer",
      data: data,
    }).then((response) => {
      const blob = new Blob([response.data], { type: "application/pdf" });
      window.open(URL.createObjectURL(blob));
    });
  };

  salir = () => {
    this.props.history.push("/cierreRe");
  };

  render() {
    const total = this.state.filas.reduce(
      (suma, fila) => suma + parseFloat(fila.variable4 || 0),
      0
    );
    return (
      <div className="principal-pago row">
        <div className="contenedor-cxc col-12">
          <div className="titulo-cxc ">
            <p>CUADRE EFECTIVO.</p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}
          <div className="historia-contenidoant">
            <div className="form-groupev col-12">
              <div className="row">
                <div className="cont-personal col-12">
                  {this.props.usuario1.nivel === "1" && (
                    <div className="contenedorcedula1f col-2">
                      <label className="opcion">Sede.</label>
                      <select
                        id="sede"
                        name="sede"
                        value={this.state.sede}
                        onChange={this.onChange}
                      >
                        <option value="">-Seleccione Sucursal-</option>
                        {this.state.sedes.map((item) => (
                          <option key={item.variable1} value={String(item.variable1)}>
                            {item.variable2}
                          </option>
                        ))}
                        <option value="0">Todas</option>
                      </select>
                    </div>
                  )}
                  <div className="contenedorcedula1f col-2">
                    <label className="opcion">Desde.</label>
                    <input
                      className="form-control"
                      type="date"
                      name="desde"
                      value={this.state.desde}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="contenedorcedula1f col-2">
                    <label className="opcion">Hasta.</label>
                    <input
                      className="form-control"
                      type="date"
                      name="hasta"
                      value={this.state.hasta}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="botones col-12">
                  <div className="acciones">
                    <button
                      className="boton"
                      onClick={this.consultar}
                      disabled={this.state.consultando}
                    >
                      {this.state.consultando ? "Procesando..." : "Consultar"}
                    </button>
                    {this.state.consultando && (
                      <span className="cuadre-ef-procesando">
                        Procesando, espere un momento...
                      </span>
                    )}
                    <button className="boton" onClick={this.imprimir}>
                      Imprimir
                    </button>
                    <button className="boton" onClick={this.salir}>
                      Salir
                    </button>
                  </div>
                </div>
              </div>
              {this.state.filas.length > 0 && (
                <table className="cuadre-ef-tabla">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Sede</th>
                      <th>Total efectivo</th>
                      <th>Revisado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.filas.map((fila) => (
                      <tr key={fila.variable1 + "-" + fila.variable2}>
                        <td className="cen">{fila.variable1}</td>
                        <td>{fila.variable3}</td>
                        <td className="num">
                          {parseFloat(fila.variable4).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="cen">
                          <input
                            type="checkbox"
                            checked={String(fila.variable5) === "1"}
                            onChange={(e) => this.marcarRevision(fila, e.target.checked)}
                          />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan="2" className="num">
                        <strong>Total</strong>
                      </td>
                      <td className="num">
                        <strong>
                          {total.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </strong>
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};

export default withRouter(connect(mapStateToProps)(CuadreEfectivo));
